import { render, staticRenderFns } from "./Director.vue?vue&type=template&id=584fd75c&scoped=true"
import script from "./Director.vue?vue&type=script&lang=js"
export * from "./Director.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584fd75c",
  null
  
)

export default component.exports